"use strict";

import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.ends-with.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.string.match.js";
import "core-js/modules/es.string.starts-with.js";
import "core-js/modules/web.dom-collections.iterator.js";
/**
 * Detects the base path for the current MFE application
 * This is a generic solution that works for any MFE
 */
export function getBasePath() {
  // 1. Check for webpack public path (most reliable when set)
  if (typeof __webpack_public_path__ !== 'undefined' && __webpack_public_path__) {
    const webpackPath = __webpack_public_path__;
    // Remove trailing slash and return
    return webpackPath.endsWith('/') ? webpackPath.slice(0, -1) : webpackPath;
  }

  // 2. Check for a base-url meta tag (can be set by the app shell)
  if (typeof document !== 'undefined') {
    const baseMeta = document.querySelector('meta[name="base-url"]');
    if (baseMeta) {
      const baseUrl = baseMeta.getAttribute('content') || '';
      return baseUrl.endsWith('/') ? baseUrl.slice(0, -1) : baseUrl;
    }
  }

  // 3. Try to detect from currently loaded script tags
  if (typeof document !== 'undefined') {
    const scripts = document.getElementsByTagName('script');
    for (let i = 0; i < scripts.length; i++) {
      const src = scripts[i].src;
      // Look for main or runtime scripts which indicate the base path
      if (src && (src.includes('/main-') || src.includes('/runtime-'))) {
        // Extract everything before the filename
        const pathMatch = src.match(/^(.*)\/[^/]+$/);
        if (pathMatch) {
          return pathMatch[1];
        }
      }
    }
  }

  // 4. Try to detect from the current window location
  // This is useful for MFEs served from specific paths
  if (typeof window !== 'undefined') {
    const pathname = window.location.pathname;

    // Look for common MFE patterns in the URL
    // Match paths like /mfe-name/... or /tenant/mfe-type/...
    const mfePatterns = [/^(\/[^/]+\/custom-fleet)/,
    // e.g., /au/custom-fleet
    /^(\/[^/]+\/supplier)/,
    // e.g., /au/supplier
    /^(\/[^/]+\/fleet-portal)/,
    // e.g., /au/fleet-portal
    /^(\/[a-z-]+)(?:\/|$)/ // Generic single-segment MFE path
    ];
    for (const pattern of mfePatterns) {
      const match = pathname.match(pattern);
      if (match) {
        // Check if this looks like an MFE path (has static assets)
        // by seeing if we can find any script tags loaded from this path
        const potentialPath = match[1];
        const scripts = document.getElementsByTagName('script');
        for (let i = 0; i < scripts.length; i++) {
          var _scripts$i$src;
          if ((_scripts$i$src = scripts[i].src) !== null && _scripts$i$src !== void 0 && _scripts$i$src.includes(potentialPath)) {
            return potentialPath;
          }
        }
      }
    }
  }

  // 5. Default fallback - assume serving from root
  return '';
}

/**
 * Gets the full URL for a resource given its path
 * @param resourcePath The path to the resource (e.g., /locales/en/common.json)
 * @param basePath Optional base path override
 */
export function getResourceUrl(resourcePath, basePath) {
  const base = basePath !== undefined ? basePath : getBasePath();

  // Ensure the resource path starts with /
  const normalizedPath = resourcePath.startsWith('/') ? resourcePath : `/${resourcePath}`;

  // If we have a base path, prepend it
  if (base) {
    return `${base}${normalizedPath}`;
  }

  // Otherwise return the path as-is
  return normalizedPath;
}